module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lwR8x"))).then(() => module.bundle.root('iDabs'));